<app-menu-template3>
    <section id="notificaciones-component" class="p-4">
        <h5 class="h5 mb-5">Centro de mensajes</h5>
        <div class="row notification-wrapper">
            <div class="col-4">
                <div class="row align-items-start">
                    <div id="search-input" class="input-group mb-2 col-8">
                        <input type="text" class="form-control" placeholder="Buscador" 
                                [(ngModel)]="filtro.texto" (keyup.enter)="realizarBusqueda()">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" (click)="realizarBusqueda()">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                    </div>
                    <button class="btn btn-outline-dark btn-sm b-0 d-flex align-items-center"
                            [ngbPopover]="filtrosDeBusqueda" placement="right" 
                            [autoClose]="'outside'">
                        <mat-icon>filter_alt</mat-icon>
                        <span class="text-underline ml-1">Filtrar</span>
                    </button>
                    <ng-template #filtrosDeBusqueda>
                        <h6 class="text-bold mb-3 pt-2">Filtros</h6>
                        <mat-radio-group class="d-flex flex-column" [(ngModel)]="filtro.buscarPor">
                            <mat-radio-button *ngFor="let item of filtersAllowed.searching" 
                                    [value]="item">
                                {{item}}
                            </mat-radio-button>
                        </mat-radio-group>
                        <h6 class="text-bold mb-3 pt-2">Organizar</h6>
                        <mat-radio-group class="d-flex flex-column" [(ngModel)]="filtro.ordenarPor">
                            <mat-radio-button *ngFor="let item of filtersAllowed.orderBy" 
                                    [value]="item">
                                {{item}}
                            </mat-radio-button>
                        </mat-radio-group>
                        <div class="d-flex justify-content-center">
                            <button class="btn btn-outline-secondary b-0" (click)="limpiarFiltros()">Cancelar</button>
                            <button class="btn btn-primary ml-2" (click)="realizarBusqueda()">Filtrar</button>
                        </div>
                    </ng-template>
                </div>
                <div class="card message-list-item"
                    [ngClass]="{'align-items-center justify-content-center':notificaciones.length <=0 }">
                    <ng-container *ngIf="notificaciones.length <= 0">
                        <img src="assets/images/sin_establecimiento.png" height="150" alt="Sin elementos">
                        <h6 class="mt-2 font-italic text-center">
                            No se encontraron mensajes
                        </h6>
                    </ng-container>
                    <div class="list-group flex-grow-1" *ngIf="notificaciones.length > 0">
                        <button *ngFor="let item of notificaciones"
                                type="button" class="list-group-item list-group-item-action" 
                                [ngClass]="{'active':item.activo}"
                                (click)="visualizarNotificacion(item)">
                            <div class="d-flex justify-content-end">
                                <mat-icon>{{item.leido ? 'drafts' : 'mail'}}</mat-icon>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <div style="max-width: calc(100% - 80px);">
                                    <h6 class="mb-0">{{item.asunto}}</h6>
                                    <small>{{item.remitente}}</small>
                                </div>
                                <small class="text-center">
                                    {{item.fecha | date:'dd/MM/yyyy'}}
                                    <br>
                                    {{item.fecha | date:'hh:mm aa'}}
                                </small>
                            </div>
                        </button>
                    </div>
                    <div *ngIf="notificaciones.length > 0" class="message-list-paginator d-flex justify-content-end align-items-center">
                        <button class="btn btn-sm btn-outline-dark" (click)="notificationPrevPage()" [disabled]="!puedeIrAPaginaAnterior">
                            <mat-icon>chevron_left</mat-icon>
                        </button>
                        <button class="btn btn-sm btn-outline-dark" (click)="notificationNextPage()" [disabled]="!puedeIrAPaginaSiguiente">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card message-wrapper"
                        [ngClass]="{'align-items-center justify-content-center': !notificacionSeleccionada }">
                    <ng-container *ngIf="!notificacionSeleccionada">
                        <mat-icon class="empty-selecion-notification--image">mail</mat-icon>
                        <h6 class="empty-selecion-notification--label">Seleccione un mensaje para leerlo</h6>
                    </ng-container>
                    <ng-container *ngIf="notificacionSeleccionada">
                        <table>
                            <tr>
                                <td>Fecha:</td>
                                <td>{{notificacionSeleccionada.fecha | date: 'EEEE, dd \'d\'e MMMM \'d\'e yyyy, hh:mm aa'}}</td>
                            </tr>
                            <tr>
                                <td>De:</td>
                                <td>{{notificacionSeleccionada.remitente}}</td>
                            </tr>
                            <tr>
                                <td>Asunto:</td>
                                <td>{{notificacionSeleccionada.asunto}}</td>
                            </tr>
                        </table>
                        <hr>
                        <div [innerHTML]="notificacionSeleccionada.mensaje"></div>
                    </ng-container>
                </div>
            </div>
        </div>
    </section>
</app-menu-template3>
